import React, { useEffect, useState } from 'react';
import { Link, useHistory } from "react-router-dom"
// import "./assets/css/main.css"
import { api_call, empty } from '../helpers/untils';
import { HOME_VIDEO_ID } from '../config/constant';
import 'react-modal-video/scss/modal-video.scss';
import ModalVideo from 'react-modal-video';

const FrontSiteFooter = (props) => {
    const history = useHistory()

    return (
        <React.Fragment>
            <div className="bg-dark overflow-hidden">
                <div className="container content-space-2 ">
                    <div className="w-md-75 w-lg-60 text-center mx-md-auto mb-5 mb-md-6">
                        <h3 className="text-white mb-3">This device is hard wired and we will help you locate a local installer.</h3>
                    </div>

                    <div className="d-md-flex justify-content-center align-items-md-center text-center">
                        <div className="d-md-flex justify-content-start align-items-md-center text-center">
                            <h4 className="text-white text-indigo my-2">Instructions for installers can be found at:</h4>
                            <a className="my-2 ms-sm-3 btn d-block d-sm-inline-block btn-primary btn-transition" href="https://docs.google.com/document/d/e/2PACX-1vSoMlBHCAwoLdX24TbvOpfv8pUgCRIA0DCWHVBtA_iLO5XCOi9U5EnfQYRS486ha7HyMuIwfvcV-2sz/pub?fbclid=IwAR32Amfg6100hcXaS0Djp_McUrQ6ItvPapFVg7Kk4_eIxNrXWlaIhgKDJqs" target="_blank">&nbsp;Here&nbsp;</a>
                        </div>
                    </div>
                </div>
            </div>
            <a className="js-go-to go-to position-fixed" href="javascript:;" style={{ visibility: 'hidden' }}
                data-hs-go-to-options='{
            "offsetTop": 700,
            "position": {
                "init": {
                "right": "2rem"
                },
                "show": {
                "bottom": "2rem"
                },
                "hide": {
                "bottom": "-2rem"
                }
            }
            }'>
                <i className="bi-chevron-up"></i>
            </a>
        </React.Fragment>
    );
};

export default FrontSiteFooter;
